import { DefaultPageComponent } from "./default.component";
import { NgModule } from "@angular/core";

@NgModule({
  declarations: [ DefaultPageComponent ],
  exports: [ DefaultPageComponent ]
})
export class PlDefaultPageModule { }
